import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LeadProvider } from "./lib/leadContext";
import HomePage from "./pages/HomePage";
import LegalPage from "./pages/LegalPage";
import {BlogIndex, BlogArticle} from "./pages/BlogPage";
import { Toaster } from "sonner";

function App() {
  return (
    <LeadProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white text-[#0B1F44]">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/terms" element={<LegalPage type="terms" />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </div>
      </BrowserRouter>
    </LeadProvider>
  );
}

export default App;
